import dynamic from 'next/dynamic';

const DynamicContactForm = dynamic(() => import('../forms/contact-form'));

export const ContactSlice = () => <DynamicContactForm />;
